module.exports = __webpack_public_path__ + "static/img/newsBanner.dae99cbb.jpg";